/*
 * @Author: Chris 
 * @Date: 2022-07-27 13:44:35 
 * @Last Modified by: Chris
 * @Last Modified time: 2022-10-27 16:02:21
 */
<template>
  <div class="ordinary_header">
    <div class="header_left">
      <img
        class="left_img"
        src="../../assets/IMG/header/header_01.png"
        alt=""
      />
      <div class="left_line"></div>
      <div class="left_name">用户管理中心</div>
    </div>
    <div class="header_right" @click="logOut">
      <div>退出</div>
      <img
        class="right_img"
        src="../../assets/IMG/header/header_out.png"
        alt=""
      />
    </div>
  </div>
</template>

<script>
import { signOut } from "../../api/api";
export default {
  name: "headerOrdinary",
  data() {
    return {};
  },
  methods: {
    logOut() {
      this.$confirm("是否确定退出本系统?", "提示", {
        confirmButtonText: "退出",
        cancelButtonText: "取消",
        type: "warning",
      }).then(async () => {
        try {
          let res = await signOut();
          if (res.code === 200) {
            window.localStorage.removeItem("UM_USER_IDENTITY");
            window.localStorage.removeItem("UM_accessToken");
            setTimeout(() => {
              this.$router.push("/login");
            }, 500);
          }
        } catch (error) {
          window.localStorage.removeItem("UM_USER_IDENTITY");
          window.localStorage.removeItem("UM_accessToken");
          setTimeout(() => {
            this.$router.push("/login");
          }, 500);
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.ordinary_header {
  width: 100%;
  height: 3.75rem;
  background: #b7282d;
  display: flex;
  align-items: center;
  justify-content: space-between;

  .header_left {
    user-select: none;
    margin-left: 2%;
    display: flex;
    align-items: center;

    .left_img {
      width: 7.5rem;
      height: 1.9375rem;
    }

    .left_line {
      margin-left: 1rem;
      height: 1.875rem;
      border-right: 0.125rem solid #fff;
    }

    .left_name {
      margin-left: 1rem;
      color: #ffffff;
      font-weight: 400;
      font-size: 0.875rem;
      line-height: 1.25rem;
    }
  }

  .header_right {
    cursor: pointer;
    user-select: none;
    margin-right: 2%;
    color: #ffffff;
    font-weight: 400;
    font-size: 0.75rem;
    line-height: 1.25rem;
    display: flex;
    align-items: center;

    .right_img {
      width: 0.75rem;
      height: 0.75rem;
      margin-left: 0.25rem;
    }
  }
}
</style>